import theme from '@ifca-root/react-component/src/assets/theme';

import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Divider, Grid, TextField, useMediaQuery } from '@material-ui/core';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import { AccordionDetails } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import AppContext from 'containers/App/Store/AppContext';

import {

	useGetOutletQuery,
	useGetStatisticExportLazyQuery,
	useMenuAccountXListQuery,
	usePostStExportMutation,
} from 'generated/graphql';

import React, {
	Reducer,
	useContext,
	useEffect,
	useReducer,
	useRef,
	useState,
} from 'react';
import { CSVLink } from 'react-csv';
import { useHistory } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../../AccountJournalsModule/GeneralLedgerJournal/generalLedger.scss';
import { IAction } from 'helpers/model';
import * as _ from 'underscore';
import { addDays, addMonths, endOfMonth } from 'date-fns/esm';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import { StandardDialog } from '@ifca-root/react-component/src/components/Dialog/StandardDialog';
import DateFnsUtils from '@date-io/date-fns';
import NumberFormat from 'react-number-format';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';

interface Props {
  STDate: Date
  MaxDate: Date
	Dialog: boolean;
	STExportData?: any;
	STDetailsData?: any;
}

export const StatisticTransactionForm = (props: any) => {
	useEffect(() => {
		console.log('GeneralLedgerJournalForm');
	}, []);

	///////////////// DATE SEARCH HEADER ///////////////
	const date = new Date();
	const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

	const lastDayOfLastMonth = endOfMonth(addMonths(new Date(), -1));
	var dateFormat = require('dateformat');
	const initialState: Props = {
		STDate: dateFormat(lastDayOfLastMonth, 'yyyy-mm-dd'),
    MaxDate: lastDayOfLastMonth,
		Dialog: false,
		STExportData: [],
		STDetailsData: [],
	};

	const reducer: Reducer<Props, IAction> = (state, action) => {
		switch (action.type) {
			case 'reset':
				return initialState;
			default:
				return { ...state, [action.type]: action.payload };
		}
	};
	const [state, dispatch] = useReducer(reducer, initialState);

	console.log(state,'state')

	const [ErrDialog, setErrDialog] = useState(false);

	const [message, setMessage] = useState('');

	const stripGraphQLErrorMessage = (message) => {
    return message.replace(/^Error: GraphQL error: Error: /, '');
  };

	const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();


	const { globalState, dispatches } = useContext(AppContext as any);
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const outletID = localStorage.getItem('latestOutlet');
	const user = JSON.parse(localStorage.getItem('loggedInUser'));

  const handleDateChangeWithLastDay = (date) => {
    dispatch({ type: 'reset', payload: {} })

    const lastDay = dateFormat(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-mm-dd')

    dispatch({ type: 'STDate', payload: lastDay })

    getSTExportData({
      variables: {
        outletID: outletID,
        accountID: user.accountID,
        date: lastDay,
      }
    })
  }

	const [
		getSTExportData,
		{ loading: stExportLoading, data: { getStatisticExport } = { getStatisticExport: [] } }
	] = useGetStatisticExportLazyQuery({
		fetchPolicy: 'no-cache',
	});
	

	console.log(getStatisticExport,'getStatisticExport')

	const {
		loading: outletLoading,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});

	const {
		loading: MenuAccountXListLoading,
		data: { MenuAccountXList } = { MenuAccountXList: [] },
	} = useMenuAccountXListQuery({
		variables: {
			outletID: outletID,
		},
		fetchPolicy: 'no-cache',
	});

	const [stPost, { loading: stPostLoading }] = usePostStExportMutation({
		onError: error => {
			if (error.graphQLErrors[0].message) {
				setErrDialog(true);
				setMessage(`${error.graphQLErrors[0].message}`);
				snackFunc('Posted Fail', false);
			}
		},
		onCompleted: y => {
			if (y.postSTExport === true) {
				csvRef.current.link.click();
				snackFunc('Posted Succesfully', true);
				getSTExportData({
					variables: {
						date: state.STDate,
						outletID: outletID,
						accountID: user.accountID,
					},
				});
				dispatch({
					type: 'reset',
					payload: {},
				});
			}
		},
	});

	const [openExitDialog, setOpenExitDialog] = useState(false);

	const ErrorDialog = (
		<StandardDialog
			fullWidth={true}
			open={ErrDialog}
			onClose={() => {
				setErrDialog(true);
			}}
			sections={{
				header: {
					title: 'Statistic Transfer Error',
				},
				body: () => <div>{`${message}`}</div>,
				footer: {
					actions: [
						{
							displayText: 'OK',
							props: {
								onClick: () => {
									setErrDialog(false);
								},
								variant: 'contained',
								color: 'primary',
							},
						},
					],
				},
			}}
		/>
	);
	useEffect(() => {
		if (getStatisticExport?.length > 0)
			dispatch({
				type: 'STDetailsData',
				payload: getStatisticExport,
			});
	}, [getStatisticExport]);


	//Export stuff
	let csvRef = useRef(null);

	const downloadSTExport = async () => {
    const statisticJournalInput = state?.STDetailsData?.map(x => ({
      JournalDate: dateFormat(x?.JournalDate, 'yyyy-mm-dd'),
			TrxDate: dateFormat(x?.TrxDate, 'yyyy-mm-dd'),
      StatisticType: x?.StatisticType,
      Description: x?.Description,
      Department: x?.Department,
      Division: x?.Division,
      AccountCode: x?.AccountCode,
      Amount: Number(x?.Amount || 0),
			Source :x?.Source,
			SourceID : x?.SourceID,
      DisplaySeq: x?.DisplaySeq,
    }))

    stPost({
			variables: {
				startDate: state.STDate,
				outletID: outletID,
				accountID: user.accountID,
				StatisticJournalInput: statisticJournalInput,
				isStatisticTransfer: MenuAccountXList?.vendorName === 'AccountX' ? true : false,
			},
    }).then(i => {
      if (i.data.postSTExport.STPost === true) {
        let csvData;
        csvData = i.data.postSTExport.ExportedSTTransfer
          ?.map(x => ({
            JournalDate: `${dateFormat(x.JournalDate, 'dd/mm/yyyy')}`,
            JournalType: x.JournalTypeName,
            RefNo: x.DocNo,
            JournalDescription: x.Description.replace(/["\\/]/g, ''),
            AccountName: x.AccountName.replace(/["\\/]/g, ''),
            MasterCOACode: x.MasterCOACode,
            DepartmentCode: x.DepartmentCode,
            Remark: x.Remark.replace(/["\\/]/g, ''),
            DocAmt: Number(x.Amount),
          }))

        dispatch({ type: 'STExportData', payload: csvData })
        snackFunc(`Posted Successfully`, true)
        csvRef.current.link.click()
      } else {
        snackFunc(`Post failed`, true)
      }
    }).catch(e => {
      snackFunc('Posted Fail', false)
      setErrDialog(true)
      dispatch({
        type: 'Dialog',
        payload: false,
      })
    })
  }

	const [downloadSuccess, setDownloadSuccess] = useState(false);
	useEffect(() => {
		const hasNullAccountCode = getStatisticExport.find(
			x => x?.AccountCode === null || x?.AccountCode === '',
		);
		if (hasNullAccountCode && !downloadSuccess) {
			snackFunc('Account Code not setup in Statistic Mapping', false);
		}
	}, [getStatisticExport, downloadSuccess]);

	console.log(MenuAccountXList?.vendorName !== 'AccountX', 'accountx');

	const Display = (hidden?: boolean) => {
		return (
			<div
				style={
					hidden
						? {
								zIndex: -40,
								top: 0,
								left: 0,
								position: 'fixed',
								width: '100%',
						  }
						: {
								marginTop: '0px',
								zIndex: 40,
								position: 'relative',
						  }
				}
				className={hidden ? 'hidden-content' : null}
			>
				<div
					id={!hidden ? 'gl' : 'hiddenGl'}
					style={
						hidden
							? { marginTop: '-85px', width: '100%', height: '100%' }
							: { width: '100%', height: '100%' }
					}
				>
					<ContentWrapper
						float
						footer
						onlyContentScrollable
						style={{
							marginTop: isDesktop ? '152px' : '86px',
						}}
					>
						{state?.STDetailsData?.length === 0 ? (
							<EmptyList title="No Record Found" />
						) : (
							<Accordion className="accordion-card">
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="panel-content"
									id="panel-header"
								>
									<Grid container justifyContent="flex-start">
										<Grid
											item
											xs={6}
											className="xsTitle"
											style={{
												whiteSpace: 'normal',
											}}
										>
											Statistic
										</Grid>
									</Grid>
								</AccordionSummary>

								<AccordionDetails>
									{state?.STDetailsData?.map((trx) => (
										<Grid
											container
											justifyContent="flex-start"
											className="desc"
											key={trx?.ID}
											style={{ width: '96%', padding: '4px' }}
										>
											<Grid item xs={5} className="desc" style={{ padding: '4px' }}>
												{trx?.Description}
											</Grid>
											<Grid item xs={5} className="desc" style={{ padding: '4px' }}>
												{trx?.Department || 'DEP'} / {trx?.Division || 'DIV'} / {trx?.AccountCode}
											</Grid>
											{trx?.StatisticType === 'External' ? (
												<Grid
													item
													xs={2}
													className="desc"
													style={{ display: 'flex', justifyContent: 'end', padding: '4px' }}
												>
													<NumberFormat
														thousandSeparator
														name="Amount"
														customInput={TextField}
														allowNegative={false}
														defaultValue={trx?.Amount}
														onChange={(e) => {
															const updatedData = state?.STDetailsData?.map((item) =>
																item?.ID === trx?.ID ? { ...item, Amount: e.target.value } : item
															);

															dispatch({
																type: 'STDetailsData',
																payload: updatedData,
															});
														}}
														decimalScale={2}
														className="left"
													/>
												</Grid>
											):
										<Grid
													item
													xs={2}
													className="desc"
													style={{ display: 'flex', justifyContent: 'end', padding: '4px' }}
												>
											{trx?.Amount}
										</Grid>
											}
											<Divider variant="fullWidth" className="flex" />
										</Grid>
									))}
								</AccordionDetails>
							</Accordion>
						)}
					</ContentWrapper>


				</div>
			</div>
		);
	};

	return (
		<>
			{outletLoading && <Loading />}
			{(stExportLoading || stPostLoading || MenuAccountXListLoading ||stExportLoading) && (
				<Loading />
			)}
			<MainHeader
				onClick={() => {
					setOpenExitDialog(true);
				}}
				mainBtn="back"
				smTitle={`Outlet App`}
				title={getOutlet[0]?.name}
				routeSegments={[
					{ name: 'Account Journals' },
					{ name: 'Statistic Journal', current: true },
				]}
				// rightRouteSegments={[{ name: mode === 'edit' ? 'Edit' : 'Add' }]}
				rightRouteSegments={[{ name: 'New' }]}
			/>
			<div
				className={`fix-subheader`}
				style={{
					marginTop: '90px',
					//marginBottom: isDesktop && globalState.drawerOpen ? 115 : 0,
				}}
			>
				<div
					className={`dynamic-subheader multiple`}
					style={{
						paddingBottom: '10px',
						height: '88px',
						width:
							isDesktop && globalState.drawerOpen
								? 'calc(100% - 285px)'
								: isDesktop && !globalState.drawerOpen
								? 'calc(100% - 47px) '
								: '100%',
					}}
				>
					{/* <Grid
						container
						direction="row"
						justifyContent="space-between"
						spacing={2}
					> */}

					<Grid item xs={12} container justifyContent="center">
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						format="dd MMM yyyy"
						openTo="month"
						views={["year", "month"]}
						className="custom-date-reservation"
						autoOk
						inputVariant="outlined"
						id="date-picker-dialog"
						value={state?.STDate}
						maxDate={state?.MaxDate}
						onChange={handleDateChangeWithLastDay}
						showTodayButton={false}
						KeyboardButtonProps={{
							style: {},
							'aria-label': 'change date',
						}}
						style={{
							zIndex: 40,
							width: '100%',
							boxShadow: 'revert',
						}}
						InputProps={{
							style: {
								fontSize: '10px',
								backgroundColor: 'white',
								color: 'black',
							},
							readOnly: true,
							fullWidth: true,
						}}
					/>
        </MuiPickersUtilsProvider>
				</Grid>
			

					{/* </Grid> */}
					<Grid
						container
						direction="row"
						justifyContent="space-between"
						spacing={2}
					>
						<Grid
							container
							direction="row"
							justifyContent="space-between"
							alignItems="center"
							style={{
								paddingRight: '12px',
								paddingLeft: '12px',
								paddingTop: '23px',
							}}
						>

						</Grid>
					</Grid>
				</div>
			</div>

			{Display()}
			{Display(true)}

			<div className="cover-layer" />
			{ErrorDialog}
	
			<CSVLink
				filename={`ST_Export_${dateFormat(state.STDate, 'dd_mm_yyyy')}.csv`}
				data={state.STExportData}
				ref={csvRef}
			/>
			<SnackBarMsg open={openSnackBar} message={snackBarMessage} />


			<DynamicFooter
				options={[
					 {
								name: 'Transfer',
								onClick: () => {
									downloadSTExport()
								},
								color:
								getStatisticExport?.length === 0 ||
								getStatisticExport.find(
										x => x?.AccountCode === '' || x?.AccountCode === null,
									)
										? 'inherit'
										: 'primary',
								disabled:
								getStatisticExport?.length === 0 ||
								getStatisticExport.find(
										x => x?.AccountCode === '' || x?.AccountCode === null,
									),
								startIcon: <ShareIcon />,
						  },
				]}
			/>
			{snackBarMessage && (
				<SnackBarMsg open={openSnackBar} message={snackBarMessage} />
			)}
			<ExitConfirmationDialog
				openExitDialog={openExitDialog}
				setOpenExitDialog={setOpenExitDialog}
				backPath={`/menu/outlet-app/account-journals/statistic-transaction`}
			/>
		</>
	);
};
